import { render, staticRenderFns } from "./call-material-manage-detail.vue?vue&type=template&id=3a9615a0&scoped=true"
import script from "./call-material-manage-detail.vue?vue&type=script&lang=js"
export * from "./call-material-manage-detail.vue?vue&type=script&lang=js"
import style0 from "./call-material-manage-detail.vue?vue&type=style&index=0&id=3a9615a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9615a0",
  null
  
)

export default component.exports